import { createFileRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { LazyComponent as LazyWrapper } from '@/components/ui';

const RepresentativeDashboardPage = lazy(() => import('../pages/RepresentativeDashboardPage'));

const SubstituteDashboardPage = () => (
  <LazyWrapper>
    <RepresentativeDashboardPage />
  </LazyWrapper>
);

export const Route = createFileRoute('/_protected/substitute/dashboard')({
  loader: async () => {
    const { default: i18n } = await import('../i18n');
    await i18n.loadNamespaces?.(['dashboard', 'common']);
    return null;
  },
  component: SubstituteDashboardPage,
});
